<template>
    <div class="proof_review_main">
        <div v-if="order && isAuthenticatedClient">
            <section class="p-0 opr_status_sec">
                <div class="container">
                    <div class="row">
                        <div class="col-md-4 col-lg-4 col-xl-3">
                            <div class="opr_order_id">
                                <h1 class="heading2">
                                    Order
                                    <span>#{{ order.unique_order_id }}</span>
                                </h1>
                            </div>
                        </div>
                        <div class="col-md-8 col-lg-8 col-xl-5">
                            <div class="opr_status d-flex">
                                <h2 class="heading2 font-weight-bold">
                                    <span class="font-weight-normal"
                                        >Status</span
                                    >
                                </h2>
                                <div class="select_option">
                                    <h2
                                        class="heading2 font-weight-bold"
                                        v-if="
                                            order.NewOrderItems[current_index]
                                                .order_review_items[version - 1]
                                                .status != 'APPROVED'
                                        "
                                    >
                                        On hold awaiting Approval
                                    </h2>
                                    <h2
                                        class="heading2 font-weight-bold text-success"
                                        v-else
                                    >
                                        Approved
                                    </h2>
                                    <v-select
                                        class="no-print"
                                        v-if="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            ).length > 0
                                        "
                                        label="version_id"
                                        @input="onChangeVersionApproval"
                                        :reduce="(item) => item.version_id"
                                        :options="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            )
                                        "
                                        :placeholder="
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items.filter(
                                                (review_item) =>
                                                    review_item.status !=
                                                    'APPROVED'
                                            ).length + ' more approval pending'
                                        "
                                    >
                                        <template
                                            slot="selected-option"
                                            slot-scope="option"
                                        >
                                            {{ option.version_id }} approval
                                            pending
                                        </template>
                                        <template v-slot:option="option">
                                            <span :class="option.icon"></span>
                                            {{ option.version_id }} approval
                                            pending
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-4">
                            <div class="opr_note">
                                <p class="secondary_light_grey m-0">
                                    <b class="secondary_black">Note:</b> Changes
                                    or Delayed approval may result in extended
                                    production time and or additional
                                    artwork/proof charges
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="p-0 opr_items_no_sec">
                <div class="container">
                    <div class="row align-items-center">
                        <div class="col-md-12 col-lg-12 col-xl-6">
                            <div
                                class="opr_items_no d-flex align-items-center flex-wrap"
                            >
                                <h3 class="heading4 mb-0 items_no_h3">
                                    Item #
                                    <span>
                                        {{
                                            order.NewOrderItems[current_index]
                                                .product_number
                                        }}</span
                                    >
                                </h3>
                                <h3 class="heading4 mb-0 items_name_h3">
                                    {{
                                        order.NewOrderItems[current_index].name
                                    }}
                                </h3>
                                <h3 class="heading4 mb-0 items_update_h3">
                                    Updated Proof:
                                    {{
                                        new Date(
                                            order.NewOrderItems[
                                                current_index
                                            ].order_review_items[
                                                version - 1
                                            ].updated_at
                                        ).toLocaleDateString("es-CL")
                                    }}
                                </h3>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-6">
                            <div
                                class="d-flex align-items-center justify-content-end"
                            >
                                <div
                                    class="opr_approvel_right_box d-flex align-items-center"
                                >
                                    <div
                                        :class="`opr_approvel_space_box ${
                                            current_index == index
                                                ? 'active'
                                                : ''
                                        }`"
                                        style="cursor: pointer"
                                        v-for="(
                                            item, index
                                        ) in order.NewOrderItems.slice(
                                            0,
                                            remaining_from
                                        )"
                                        :key="index"
                                    >
                                        <div
                                            class="opr_approvel_img_box cursor-pointer"
                                            @click="onSelectReviewItem(index)"
                                        >
                                            <p>
                                                <img
                                                    :src="
                                                        item.product_image
                                                            .thumbnail
                                                    "
                                                    alt=""
                                                />
                                            </p>
                                            <h3>{{ item.name }}</h3>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="opr_approvel_order_box no-print"
                                    v-if="
                                        order.NewOrderItems.slice(
                                            remaining_from
                                        ).length > 0
                                    "
                                >
                                    <div
                                        class="dropdown"
                                        id="opr_dropdown_toggle_custom"
                                    >
                                        <a
                                            href="javascript:void(0)"
                                            id="opr_approvel_order"
                                            @click="orderFunction()"
                                        >
                                            +{{
                                                order.NewOrderItems.slice(
                                                    remaining_from
                                                ).length
                                            }}
                                        </a>
                                        <div class="dropdown-menu">
                                            <h4 class="font_size_24 mb_30">
                                                All products requiring approval
                                                on this order:
                                            </h4>
                                            <div class="dropdown-item p-0">
                                                <div
                                                    class="opr_approvel_product_drop d-flex cursor-pointer"
                                                    @click="
                                                        onSelectRemainingItem(
                                                            index + 3
                                                        )
                                                    "
                                                    style="cursor: pointer"
                                                    v-for="(
                                                        item, index
                                                    ) in order.NewOrderItems.slice(
                                                        remaining_from
                                                    ).filter(
                                                        (item) =>
                                                            item.order_review_items
                                                    )"
                                                    :key="index"
                                                >
                                                    <div
                                                        class="opr_approvel_product_drop_img mr_16"
                                                    >
                                                        <span>
                                                            <img
                                                                :src="
                                                                    item
                                                                        .product_image
                                                                        .thumbnail
                                                                "
                                                                alt=""
                                                            />
                                                        </span>
                                                    </div>
                                                    <div
                                                        class="opr_approvel_product_drop_content"
                                                    >
                                                        <h4
                                                            class="d-flex justify-content-between mb_0"
                                                        >
                                                            {{ item.name }}
                                                        </h4>

                                                        <p class="mb_10">
                                                            Price:
                                                            <b class="ml_4"
                                                                >${{
                                                                    showGrandTotalPrice(
                                                                        item
                                                                    )
                                                                }}</b
                                                            >
                                                        </p>
                                                        <p
                                                            class="on_hold status_custom_box mb_0"
                                                        >
                                                            In Review
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section class="opr_version_image_sec pb-0">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="opr_version_select">
                                <div class="select_option m-0">
                                    <v-select
                                        style="width: 10%"
                                        label="version_id"
                                        v-model="version"
                                        :clearable="false"
                                        :reduce="(item) => item.version_id"
                                        :options="
                                            order.NewOrderItems[current_index]
                                                .order_review_items
                                        "
                                    >
                                        <template
                                            slot="selected-option"
                                            slot-scope="option"
                                        >
                                            Version {{ option.version_id }}
                                        </template>
                                        <template v-slot:option="option">
                                            <span :class="option.icon"></span>
                                            Version {{ option.version_id }}
                                        </template>
                                    </v-select>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-12 col-lg-12 col-xl-8">
                            <div
                                v-if="
                                    order.NewOrderItems[current_index]
                                        .order_review_items[version - 1].artwork
                                "
                                class="row"
                            >
                                <div class="col-md-6">
                                    <div
                                        class="opr_version_img text-center mt_40"
                                    >
                                        <img
                                            :src="
                                                order.NewOrderItems[
                                                    current_index
                                                ].product_image.thumbnail
                                            "
                                            alt=""
                                        />
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div
                                        class="opr_version_img text-center mt_40"
                                    >
                                        <img
                                            :src="
                                                order.NewOrderItems[
                                                    current_index
                                                ].order_review_items[
                                                    version - 1
                                                ].artwork
                                            "
                                            alt=""
                                        />
                                    </div>
                                </div>
                            </div>

                            <div v-else class="">
                                <ul
                                    class="nav nav-tabs"
                                    id="nav-tab"
                                    role="tablist"
                                >
                                    <li
                                        class="nav-link"
                                        :class="{
                                            active: designImage.active_tab
                                        }"
                                        v-for="(
                                            designImage, designImageIndex
                                        ) in order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .design_images"
                                        :key="designImageIndex"
                                        @click="
                                            activeDesignImageTab(designImage)
                                        "
                                    >
                                        <a
                                            class="nav-link"
                                            aria-current="page"
                                            href="javascript:void(0);"
                                            >{{ designImage.label }}</a
                                        >
                                    </li>
                                </ul>

                                <div class="tab-content" id="nav-tabContent">
                                    <div
                                        id="nav-home"
                                        role="tabpanel"
                                        aria-labelledby="nav-home-tab"
                                        class="tab-pane fade"
                                        :class="{
                                            'show active':
                                                designImage.active_tab
                                        }"
                                        v-for="(
                                            designImage, designImageIndex
                                        ) in order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .design_images"
                                        :key="designImageIndex"
                                    >
                                        <div class="row">
                                            <div class="col-md-6">
                                                <div
                                                    class="opr_version_img text-center mt_20"
                                                >
                                                    <img
                                                        :src="designImage.url"
                                                    />
                                                </div>
                                            </div>
                                            <div class="col-md-6">
                                                <div
                                                    class="opr_version_img text-center mt_20"
                                                >
                                                    <img
                                                        :src="
                                                            designImage.design_image
                                                        "
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="opr_version_img_download mt_34">
                                <h1 class="heading4 no-print">Download</h1>
                                <div
                                    class="no-print opr_download_btns d-flex justify-content-between flex-wrap"
                                >
                                    <div>
                                        <a
                                            :href="
                                                order.NewOrderItems[
                                                    current_index
                                                ].order_review_items[
                                                    version - 1
                                                ].artwork
                                            "
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue mr_22"
                                            download
                                            target="_blank"
                                        >
                                            <img
                                                src="/maincss/images/icons/picture.svg"
                                                alt=""
                                            />
                                            Image</a
                                        >
                                        <a
                                            v-if="
                                                currentUserClient.id ==
                                                order.user_id
                                            "
                                            href="javascript:void(0);"
                                            data-toggle="modal"
                                            data-path=""
                                            data-target="#opr_share_popup"
                                            class="btn btn_outline_primary border_primary_blue text_primary_blue"
                                        >
                                            <img
                                                src="/maincss/images/icons/share.svg"
                                                alt=""
                                            />
                                            Share</a
                                        >
                                    </div>

                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn_primary bg_primary_blue text_white chat_btn"
                                        data-toggle="modal"
                                        data-path=""
                                        :data-target="`#opr_chat_popup${current_index}v${version}`"
                                    >
                                        <img
                                            src="/maincss/images/icons/comment.svg"
                                            alt=""
                                        />
                                        Chat
                                    </a>
                                </div>

                                <div class="opr_product_style mt_40">
                                    <p>
                                        <span class="mr_6">Product Style: </span
                                        >{{
                                            order.NewOrderItems[current_index]
                                                .product_number
                                        }}
                                    </p>
                                    <p class="d-flex align-items-center">
                                        <span class="mr_6"
                                            >Product Color:
                                        </span>
                                        <img
                                            class="mr-1"
                                            :style="'border:1px solid #c5c2c2;min-width:30px;height:30px;'"
                                            v-if="
                                                order.NewOrderItems[
                                                    current_index
                                                ].color.swatches
                                            "
                                            :src="
                                                order.NewOrderItems[
                                                    current_index
                                                ].color.swatches
                                            "
                                        />
                                        <span
                                            v-else
                                            class="mr-1"
                                            :style="`border:1px solid #c5c2c2;min-width:30px;height:30px;background: ${order.NewOrderItems[current_index].color.hex};`"
                                        ></span>
                                        {{
                                            order.NewOrderItems[current_index]
                                                .color.name
                                        }}
                                    </p>
                                    <p>
                                        <span class="mr_6">Product Sizes: </span
                                        >{{
                                            order.NewOrderItems[
                                                current_index
                                            ].sizes
                                                .map(
                                                    (sub_product) =>
                                                        sub_product
                                                            .NewSubProduct.Size
                                                            .size
                                                )
                                                .join(", ")
                                        }}
                                    </p>

                                    <div
                                        v-for="(
                                            location, location_index
                                        ) in order.NewOrderItems[current_index]
                                            .imprint_locations"
                                        :key="location_index"
                                    >
                                        <p v-if="location.colors.length > 0">
                                            <span class="mr_6"
                                                >Imprint Location:
                                            </span>
                                            {{ location.location }}
                                        </p>

                                        <div
                                            class="d-flex align-items-center color_style_one mt_10"
                                            v-for="(
                                                colors, color_key
                                            ) in location.colors"
                                            :key="color_key"
                                        >
                                            <span class="mr_6 color_count"
                                                >Color {{ color_key + 1 }}:
                                            </span>

                                            <img
                                                v-if="colors.color.swatches"
                                                class="color_img"
                                                :src="colors.color.swatches"
                                                :style="`border:1px solid #c5c2c2;min-width:30px;height:30px;`"
                                                alt=""
                                            />
                                            <span
                                                v-else
                                                :style="`border:1px solid #c5c2c2;min-width:30px;height:30px;background: ${colors.color.color_value};`"
                                            ></span>
                                            <span class="color_name">{{
                                                colors.color.color_name
                                            }}</span>
                                        </div>
                                    </div>

                                    <div class="addi_fees">
                                        <div class="pending-amount">
                                            <h2 class="pending-heading">
                                                Additional Payment
                                            </h2>
                                            <div class="pending-block">
                                                <span
                                                    class="d-flex align-items-center pending-block-heading"
                                                    >Additional Fee:
                                                </span>
                                                <span
                                                    class="mr_6 pending-block-amount"
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            modified_fees.new_color_fee
                                                        )
                                                    }}</span
                                                >
                                            </div>

                                            <div class="pending-block">
                                                <span
                                                    class="d-flex align-items-center pending-block-heading"
                                                >
                                                    Order Fees:</span
                                                >
                                                <span
                                                    class="mr_6 pending-block-amount"
                                                >
                                                    {{
                                                        icPriceFormat(
                                                            order.total_order_fee
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                            <div class="pending-block">
                                                <span
                                                    class="d-flex align-items-center pending-block-heading"
                                                    >Item Fees:
                                                </span>
                                                <span
                                                    class="mr_6 pending-block-amount"
                                                    >{{
                                                        icPriceFormat(
                                                            modified_fees.new_design_fee
                                                        )
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="no-print col-md-12 col-lg-12 col-xl-4">
                            <div class="opr_product_color_approve_box">
                                <!--  it’s approved start -->
                                <div
                                    class="opr_its_approved_box_custom"
                                    v-if="
                                        order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .status == 'APPROVED'
                                    "
                                >
                                    <p class="mb-0">
                                        <img
                                            src="/maincss/images/icons/green_check.svg"
                                            alt=""
                                            class="mr_8"
                                        />
                                        it’s approved
                                    </p>
                                </div>
                                <!--  it’s approved End -->

                                <h2
                                    class="heading4 mb_38"
                                    v-if="
                                        order.NewOrderItems[current_index]
                                            .vendor_colors.length > 0
                                    "
                                >
                                    Product colors to approve
                                </h2>

                                <div
                                    v-for="(location, location_index) in order
                                        .NewOrderItems[current_index]
                                        .imprint_locations"
                                    :key="location_index"
                                >
                                    <div
                                        class="d-flex opr_pro_color_approve_content"
                                        v-for="(
                                            color, color_index
                                        ) in location.colors"
                                        :key="color_index"
                                    >
                                        <div>
                                            <span
                                                class="opr_color_box"
                                                :style="
                                                    'background: ' +
                                                    color.color.color_value
                                                "
                                            ></span>
                                        </div>
                                        <div>
                                            <h5 class="heading5 mb-0">
                                                {{ color.color.color_name }}
                                            </h5>
                                            <p class="font_size_14 mb-0">
                                                Ink color:
                                                {{
                                                    color.color.category
                                                        ? color.color.category
                                                        : ""
                                                }}
                                            </p>
                                            <p class="font_size_14 mb-0">
                                                Location:
                                                {{ location.location }}
                                            </p>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    class="opr_approve_modify_btn mt_6 d-flex align-items-center flex-wrap"
                                    v-if="
                                        order.NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .status != 'APPROVED' &&
                                        currentUserClient.id == order.user_id
                                    "
                                >
                                    <div class="opr_approve_box_custom">
                                        <a
                                            href="javascript:void(0);"
                                            class="btn btn_orange bg_primary_orange text_white mr_20"
                                            @click="approveArtwork"
                                        >
                                            <img
                                                src="/maincss/images/icons/check.svg"
                                                alt=""
                                            />
                                            Approve
                                        </a>
                                    </div>
                                    <!-- modify btn start -->
                                    <div class="dropdown">
                                        <a
                                            href="#"
                                            id="opr_modify_btn_popup"
                                            data-toggle="dropdown"
                                            aria-haspopup="true"
                                            aria-expanded="true"
                                            class="dropdown-toggle btn modify_btn"
                                        >
                                            Modify
                                        </a>
                                        <div
                                            aria-labelledby="dropdownMenuButtonModify"
                                            class="dropdown-menu p-0"
                                            id="modify-dropdown"
                                        >
                                            <div class="opr_modify_drop_box">
                                                <div id="accordion">
                                                    <!-- cross btn start -->
                                                    <div
                                                        class="opr_after_msg_close_btn d-none"
                                                    >
                                                        <a
                                                            href="javascript(0);"
                                                            class="ml_10"
                                                            ><img
                                                                src="/maincss/images/cancel.svg"
                                                                alt=" "
                                                        /></a>
                                                    </div>
                                                    <!-- cross btn end -->

                                                    <div class="card">
                                                        <div
                                                            class="card-header"
                                                            id="headingOne"
                                                        >
                                                            <h5 class="mb-0">
                                                                <button
                                                                    class="btn btn-link"
                                                                    data-toggle="collapse"
                                                                    data-target="#collapseOne"
                                                                    aria-expanded="true"
                                                                    aria-controls="collapseOne"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/icons/down_arrow.svg"
                                                                        alt=""
                                                                        class="mr_6"
                                                                    />Approved
                                                                    with
                                                                    Modification
                                                                </button>
                                                            </h5>
                                                        </div>

                                                        <div
                                                            id="collapseOne"
                                                            class="collapse show"
                                                            aria-labelledby="headingOne"
                                                            data-parent="#accordion"
                                                        >
                                                            <div
                                                                class="card-body pt-0"
                                                            >
                                                                <div
                                                                    id="approved_with_modification"
                                                                    class="approved_noti_text_area"
                                                                >
                                                                    <form
                                                                        action=""
                                                                        class="form-group m-0"
                                                                    >
                                                                        <div
                                                                            class="mb_24"
                                                                        >
                                                                            <textarea
                                                                                name=""
                                                                                cols="30"
                                                                                rows="2"
                                                                                class="form-control"
                                                                                placeholder="Comment"
                                                                                v-model="
                                                                                    comment
                                                                                "
                                                                            ></textarea>
                                                                        </div>
                                                                        <div>
                                                                            <a
                                                                                href="javascript:void(0);"
                                                                                class="btn btn_primary bg_primary_blue text_white"
                                                                                @click="
                                                                                    approveWithModification
                                                                                "
                                                                                >Submit</a
                                                                            >
                                                                        </div>
                                                                    </form>
                                                                </div>

                                                                <!-- WE will get back to you start -->
                                                                <div
                                                                    id="approved_with_modification_msg"
                                                                    class="opr_we_will_get_back d-none"
                                                                >
                                                                    <p
                                                                        class="mb-0"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/icons/green_check.svg"
                                                                            alt=""
                                                                            class="mr_8"
                                                                        />
                                                                        WE will
                                                                        get back
                                                                        to you
                                                                    </p>
                                                                </div>
                                                                <!-- WE will get back to you end -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="card">
                                                        <div
                                                            class="card-header"
                                                            id="headingTwo"
                                                        >
                                                            <h5 class="mb-0">
                                                                <button
                                                                    class="border-0 btn btn-link collapsed"
                                                                    data-toggle="collapse"
                                                                    data-target="#collapseTwo"
                                                                    aria-expanded="false"
                                                                    aria-controls="collapseTwo"
                                                                >
                                                                    <img
                                                                        src="/maincss/images/icons/down_arrow.svg"
                                                                        alt=""
                                                                        class="mr_6"
                                                                    />Resend
                                                                    Proof with
                                                                    Updates
                                                                </button>
                                                            </h5>
                                                        </div>
                                                        <div
                                                            id="collapseTwo"
                                                            class="collapse"
                                                            aria-labelledby="headingTwo"
                                                            data-parent="#accordion"
                                                        >
                                                            <div
                                                                class="card-body pt-0"
                                                            >
                                                                <div
                                                                    id="resend_with_proof_updates"
                                                                    class="approved_noti_text_area"
                                                                >
                                                                    <form
                                                                        action=""
                                                                        class="form-group m-0"
                                                                    >
                                                                        <div
                                                                            class="mb_24"
                                                                        >
                                                                            <textarea
                                                                                name=""
                                                                                id=""
                                                                                cols="30"
                                                                                rows="2"
                                                                                class="form-control"
                                                                                placeholder="Comment"
                                                                                v-model="
                                                                                    comment
                                                                                "
                                                                            ></textarea>
                                                                        </div>
                                                                        <div>
                                                                            <a
                                                                                href="javascript:void(0);"
                                                                                class="btn btn_primary bg_primary_blue text_white"
                                                                                @click="
                                                                                    resendProofWithUpdates
                                                                                "
                                                                                >Submit</a
                                                                            >
                                                                        </div>
                                                                    </form>
                                                                </div>

                                                                <!-- WE will get back to you start -->
                                                                <div
                                                                    id="resend_with_proof_updates_msg"
                                                                    class="opr_we_will_get_back d-none"
                                                                >
                                                                    <p
                                                                        class="mb-0"
                                                                    >
                                                                        <img
                                                                            src="/maincss/images/icons/green_check.svg"
                                                                            alt=""
                                                                            class="mr_8"
                                                                        />
                                                                        WE will
                                                                        get back
                                                                        to you
                                                                    </p>
                                                                </div>
                                                                <!-- WE will get back to you end -->
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- modify btn end -->
                                </div>
                                <div class="opr_note_pro_approv mt_30">
                                    <p class="mb_0">
                                        <b>Note:</b> Approval will move the
                                        order into production and Cannot be
                                        reversed! Rejection will prompt a
                                        comment section to appear for you to
                                        describe the requested changes.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- version image section end -->

            <section class="p-0">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 col-lg-12 col-xl-8">
                            <div class="opr_proof_carefilly">
                                <p>
                                    These designs are property of Imprint City
                                    and may not be reproduced in any way without
                                    permission from Imprint City.
                                </p>
                                <div class="opr_carefully_box text-center">
                                    <h2 class="heading4 font-weight-bold mb_14">
                                        Please Proof Carefully
                                    </h2>
                                    <p class="mb-0">
                                        Check spelling, content, color, imprint
                                        size and location. Placement, size and
                                        color are approximations and may look
                                        different on your screen. We are not
                                        responsible for errors noticed after
                                        your approval. Changes made after
                                        approval may result in additional fees &
                                        delays. An email reply referencing the
                                        design will be considered an approval
                                        unless changes are specified.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <!-- share model start -->
            <div
                id="opr_share_popup"
                tabindex="-1"
                aria-labelledby=""
                data-keyboard="false"
                data-backdrop="static"
                class="modal fade"
                style="display: none"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                >
                    <div class="modal-content">
                        <div
                            class="modal-header py_40 px_56 align-items-center"
                        >
                            <h1 class="heading2 mb-0">Share</h1>
                            <a
                                href="javascript:void(0);"
                                id="popup-close"
                                data-dismiss="modal"
                                class="ml_10"
                                ><img src="/maincss/images/cancel.svg" alt=" "
                            /></a>
                        </div>
                        <div class="modal-body py_40 px_56">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="opr_sahre_name_box">
                                        <p class="font_size_24">
                                            <span
                                                class="opr_share_name chat_name_orange_bg"
                                                >{{
                                                    currentUserClient.first_name.charAt(
                                                        0
                                                    ) +
                                                    currentUserClient.last_name.charAt(
                                                        0
                                                    )
                                                }}</span
                                            >
                                            {{
                                                currentUserClient.first_name +
                                                " " +
                                                currentUserClient.last_name
                                            }}
                                            (You)
                                        </p>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="opr_share_form mt_30">
                                        <form
                                            method="post"
                                            data-vv-scope="reviewmailform"
                                        >
                                            <div class="mb_32">
                                                <input
                                                    type="text"
                                                    name="sent_email"
                                                    class="form-control"
                                                    v-model="mail.email"
                                                    placeholder="Enter email"
                                                    v-validate="
                                                        'required|email'
                                                    "
                                                    data-vv-as="Email"
                                                />
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'reviewmailform.sent_email'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "reviewmailform.sent_email"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                            <div class="mb_32">
                                                <textarea
                                                    name="sent_message"
                                                    rows="7"
                                                    placeholder="Enter message"
                                                    v-model="mail.message"
                                                    class="form-control"
                                                    v-validate="'required'"
                                                    data-vv-as="Message"
                                                ></textarea>
                                                <small
                                                    class="form-text text-error text-left"
                                                    v-show="
                                                        errors.has(
                                                            'reviewmailform.sent_message'
                                                        )
                                                    "
                                                >
                                                    {{
                                                        errors.first(
                                                            "reviewmailform.sent_message"
                                                        )
                                                    }}
                                                </small>
                                            </div>
                                            <div class="opr_note_box mb_50">
                                                <p class="mb-0">
                                                    <b>Note:</b> Only you will
                                                    have the ability to approve
                                                    or reject the artwork in our
                                                    system. You may share the
                                                    proof with Other but they
                                                    will not have the ability to
                                                    approve the artwork.
                                                </p>
                                            </div>
                                            <div class="text-center">
                                                <a
                                                    href="javascript:void(0);"
                                                    class="btn btn_primary bg_primary_blue text_white"
                                                    @click="sendMail"
                                                    >Send Invite</a
                                                >
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- share model start -->

            <!-- chat model start -->
            <div
                :id="`opr_chat_popup${current_index}v${version}`"
                tabindex="-1"
                aria-labelledby=""
                data-keyboard="false"
                data-backdrop="static"
                class="modal fade opr_chat_popup_box"
                style="display: none"
                aria-hidden="true"
            >
                <div
                    class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
                >
                    <div class="modal-content">
                        <div
                            class="modal-header py_40 px_56 align-items-center"
                        >
                            <h1 class="heading2 mb-0">
                                Proofing notes from imprint city designer
                            </h1>
                            <div class="cross-refresh">
                                <a
                                    v-tooltip="'Refresh comments'"
                                    href="javascript:void(0);"
                                    class="mr_10"
                                    @click="refreshComments"
                                >
                                    <img
                                        src="/maincss/images/refresh.svg"
                                        alt=" "
                                    />
                                </a>
                                <a
                                    href="javascript:void(0);"
                                    id="popup-close"
                                    data-dismiss="modal"
                                    class="ml_10"
                                    @click="() => (this.comment = '')"
                                    ><img
                                        src="/maincss/images/cancel.svg"
                                        alt=" "
                                /></a>
                            </div>
                        </div>
                        <div class="modal-body py_40 px_56">
                            <div class="row">
                                <div class="col-md-12">
                                    <div
                                        v-for="(comment, index) in order
                                            .NewOrderItems[current_index]
                                            .order_review_items[version - 1]
                                            .OrderReviewComments"
                                        :key="index"
                                    >
                                        <div
                                            class="opr_chat_main_box d-flex"
                                            v-if="
                                                comment.commented_by !=
                                                currentUserClient.id
                                            "
                                        >
                                            <div class="opr_chat_name mr_10">
                                                <span class="chat_blue_bg">{{
                                                    comment.comment_sent_user.first_name.charAt(
                                                        0
                                                    ) +
                                                    comment.comment_sent_user.last_name.charAt(
                                                        0
                                                    )
                                                }}</span>
                                            </div>
                                            <div class="opr_chat_text">
                                                <p class="mb_8">
                                                    {{
                                                        comment
                                                            .comment_sent_user
                                                            .first_name +
                                                        " " +
                                                        comment
                                                            .comment_sent_user
                                                            .last_name
                                                    }}
                                                    {{
                                                        new Date(
                                                            comment.created_at
                                                        ).toLocaleDateString()
                                                    }}
                                                    <span
                                                        class="text_primary_blue ml_4"
                                                    >
                                                        Version-{{ version }},
                                                        Color:
                                                        {{
                                                            order.NewOrderItems[
                                                                current_index
                                                            ].color.name
                                                        }}
                                                        {{
                                                            order.NewOrderItems[
                                                                current_index
                                                            ]
                                                                .order_review_items[
                                                                version - 1
                                                            ].location
                                                                ? `, Location:
                                                        ${
                                                            order.NewOrderItems[
                                                                current_index
                                                            ]
                                                                .order_review_items[
                                                                version - 1
                                                            ].location
                                                        }`
                                                                : ""
                                                        }}
                                                    </span>
                                                </p>
                                                <div
                                                    class="chat_content_msg chat_blue_bg"
                                                >
                                                    <img
                                                        height="200px"
                                                        width="200px"
                                                        v-if="
                                                            comment.attachment
                                                        "
                                                        :src="
                                                            comment.attachment
                                                        "
                                                        alt=""
                                                    />
                                                    <p v-else>
                                                        {{ comment.comment }}
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div
                                            class="opr_chat_main_box d-flex justify-content-end"
                                            v-else
                                        >
                                            <div class="opr_chat_text">
                                                <p class="mb_8">
                                                    {{
                                                        comment
                                                            .comment_sent_user
                                                            .first_name +
                                                        " " +
                                                        comment
                                                            .comment_sent_user
                                                            .last_name
                                                    }}
                                                    {{
                                                        new Date(
                                                            comment.created_at
                                                        ).toLocaleDateString()
                                                    }}
                                                    <span
                                                        class="text_primary_blue ml_4"
                                                    >
                                                        Version-{{ version }},
                                                        Color:
                                                        {{
                                                            order.NewOrderItems[
                                                                current_index
                                                            ].color.name
                                                        }}
                                                        {{
                                                            order.NewOrderItems[
                                                                current_index
                                                            ]
                                                                .order_review_items[
                                                                version - 1
                                                            ].location
                                                                ? `, Location:
                                                        ${
                                                            order.NewOrderItems[
                                                                current_index
                                                            ]
                                                                .order_review_items[
                                                                version - 1
                                                            ].location
                                                        }`
                                                                : ""
                                                        }}</span
                                                    >
                                                </p>
                                                <div
                                                    class="chat_content_msg chat_gray_bg"
                                                >
                                                    <img
                                                        height="200px"
                                                        width="200px"
                                                        v-if="
                                                            comment.attachment
                                                        "
                                                        :src="
                                                            comment.attachment
                                                        "
                                                        alt=""
                                                    />
                                                    <p v-else>
                                                        {{ comment.comment }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="opr_chat_name ml_10">
                                                <span
                                                    class="chat_name_orange_bg"
                                                    >{{
                                                        comment.comment_sent_user.first_name.charAt(
                                                            0
                                                        ) +
                                                        comment.comment_sent_user.last_name.charAt(
                                                            0
                                                        )
                                                    }}</span
                                                >
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="opr_chat_input_box mt_34">
                            <form @submit.prevent class="form-group m-0">
                                <div
                                    class="opr_chat_input_inner_box d-flex align-items-center"
                                >
                                    <input
                                        type="text"
                                        placeholder="Write Something"
                                        class="form-control"
                                        v-model="comment"
                                        @keypress="onTypeComment"
                                    />
                                    <input
                                        type="file"
                                        @change="attachImage"
                                        class="d-none"
                                        ref="attachment"
                                        accept="image/*"
                                    />
                                    <a
                                        href="javascript:void(0);"
                                        v-if="!comment.trim()"
                                        class="ml_10 mr_30 mb-0"
                                        @click="$refs.attachment.click()"
                                        ><img
                                            src="/maincss/images/icons/clip.svg"
                                            alt=""
                                    /></a>
                                    <a
                                        href="javascript:void(0);"
                                        class="btn btn_primary mb-0 bg_primary_blue text_white"
                                        @click="postReviewComment"
                                        >Send</a
                                    >
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="preloader" v-show="isLoader">
            <div class="preloader-body">
                <svg width="40" height="40" viewBox="0 0 40 40">
                    <polygon
                        class="rect"
                        points="0 0 0 40 40 40 40 0"
                    ></polygon>
                </svg>
            </div>
        </div>
    </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { mapGetters } from "vuex";
export default {
    data() {
        return {
            order: null,
            current_index: 0,
            version: 1,
            isLoader: false,
            comment: "",
            attachment: "",
            mail: {
                email: "",
                message: "",
                unique_order_id: "",
                current_link:
                    window.location.origin +
                    "/orderproofview/" +
                    this.$route.params.id
            },
            remaining_from: 3,
            approved: false,
            modified_fees: {
                existing_color_fee: 0,
                existing_design_fee: 0,
                new_color_fee: 0,
                new_design_fee: 0
            }
        };
    },
    mounted() {
        this.getOrderDetail();
        /* eslint-disable */
        $(document).on("click", "#modify-dropdown", function (e) {
            e.stopPropagation();
        });
        /* eslint-enable */
    },
    computed: {
        ...mapGetters(["currentUserClient", "isAuthenticatedClient"])
    },
    methods: {
        orderFunction() {
            this.prepareRemainingItemFees();
            var element = document.getElementById("opr_dropdown_toggle_custom");
            element.classList.toggle("opr_approvel_order_toggle");
        },
        prepareRemainingItemFees() {
            for (
                let i = this.remaining_from;
                i <= this.order.NewOrderItems.length - 1;
                i++
            ) {
                let OrderReviewFees = this.order.OrderReviewFees.filter(
                    (review_fee) =>
                        review_fee.OrderReviewItem != null &&
                        review_fee.OrderReviewItem.product_id ==
                            this.order.NewOrderItems[i].id &&
                        review_fee.OrderReviewItem.color_id ==
                            this.order.NewOrderItems[i].color.id &&
                        review_fee.OrderReviewItem.size_group_id ==
                            this.order.NewOrderItems[i].gender_size_id &&
                        review_fee.OrderReviewItem.unique_item_id ==
                            this.order.NewOrderItems[i].unique_item_id &&
                        review_fee.OrderReviewItem.version_id == 1
                );
                let total_decoration_fee = 0;
                OrderReviewFees.forEach((review_fee) => {
                    total_decoration_fee += parseFloat(
                        review_fee.decoration_fee
                    );
                });
                this.order.NewOrderItems[i].order_review_items = [
                    { OrderReviewFees, total_decoration_fee }
                ];
            }
            this.$forceUpdate();
        },
        getOrderDetail() {
            var _this = this;
            if (!this.isAuthenticatedClient) {
                this.$router.push({ path: "/" });
                return;
            }
            _this.isLoader = true;
            new Promise((resolve, reject) => {
                ApiService.get(`/order-proof-review/${this.$route.params.id}`)
                    .then(async ({ data }) => {
                        let order = data.order;
                        let order_items = [];
                        let all_setup_fee = 0;
                        let order_review_items =
                            data.order_review_master.OrderReviewItems;
                        for (let item of data.order.NewOrderItems) {
                            let review_items = order_review_items.filter(
                                (review_item) =>
                                    review_item.product_id ==
                                        item.NewSubProduct.parent_product_id &&
                                    review_item.color_id ==
                                        item.NewSubProduct.color_id &&
                                    review_item.size_group_id ==
                                        item.gender_size_id &&
                                    review_item.unique_item_id ==
                                        item.unique_item_id
                            );
                            if (review_items.length == 0) {
                                continue;
                            }
                            let item_setup_fee = 0;
                            let order_item = item.NewSubProduct.NewProduct;
                            order_item.gender_size_id = item.gender_size_id;
                            order_item.unique_item_id = item.unique_item_id;
                            order_item.color = item.NewSubProduct.Color;
                            order_item["NewOrderItemDecoration"] =
                                item.NewOrderItemDecoration;
                            let index = order_items.findIndex(
                                (item_data) =>
                                    item_data.id ==
                                        item.NewSubProduct.parent_product_id &&
                                    item_data.color.id ==
                                        item.NewSubProduct.color_id &&
                                    item_data.gender_size_id ==
                                        item.gender_size_id &&
                                    item_data.unique_item_id ==
                                        item.unique_item_id
                            );
                            item_setup_fee =
                                item_setup_fee + parseFloat(item.setup_fee);
                            if (index >= 0 && order_items[index]) {
                                order_items[index]["sizes"].push(item);
                                order_items[index]["total_quantity"] +=
                                    item.quantity;
                                order_items[index]["total_price"] +=
                                    parseFloat(item.total_price) +
                                    parseFloat(item.setup_fee);
                            } else {
                                order_item["sizes"] = [item];
                                order_item["total_quantity"] = item.quantity;
                                order_item["total_price"] =
                                    parseFloat(item.total_price) +
                                    parseFloat(item.setup_fee);
                                order_item["setup_fee"] = item_setup_fee;
                                order_item["order_review_items"] = review_items;
                                order_item["imprint_locations"] = JSON.parse(
                                    item.imprint_locations
                                );
                                order_item["product_image"] =
                                    order_item.NewProductImages.find(
                                        (image) =>
                                            image.color_id ==
                                            order_item.color.id
                                    );
                                if (!order_item["product_image"]) {
                                    order_item["product_image"] =
                                        order_item.NewProductImages[0];
                                }
                                let vendor_colors = [];
                                if (item.imprint_locations) {
                                    JSON.parse(item.imprint_locations).forEach(
                                        (location) => {
                                            location.colors.forEach((color) => {
                                                let exist = vendor_colors.find(
                                                    (data) =>
                                                        data.color.color_id ==
                                                        color.color.color_id
                                                );
                                                if (!exist) {
                                                    vendor_colors.push(color);
                                                }
                                            });
                                        }
                                    );
                                }
                                order_item["vendor_colors"] = vendor_colors;

                                order_items.push(order_item);
                            }
                            all_setup_fee = all_setup_fee + item_setup_fee;
                        }

                        await this.getSingleOrderReview(
                            order_items[this.current_index]
                        );

                        this.version =
                            order_items[
                                this.current_index
                            ].order_review_items.length;
                        order.total_setup_fee = all_setup_fee;
                        order.NewOrderItems = order_items;
                        order.total_order_fee = 0;
                        order.order_fees = order.OrderReviewFees.filter(
                            (fee) => fee.order_review_item_id == null
                        );
                        order.order_fees.forEach((fee) => {
                            order.total_order_fee += parseFloat(
                                fee.decoration_fee
                            );
                        });
                        _this.order = order;
                        _this.isLoader = false;
                        resolve(data);
                    })
                    .catch((err) => {
                        console.log(err);
                        _this.isLoader = false;
                        reject(err);
                    });
            });
        },
        onSelectReviewItem(index) {
            if (index == this.current_index) {
                return;
            }
            this.isLoader = true;
            this.getSingleOrderReview(this.order.NewOrderItems[index])
                .then(() => {
                    this.version =
                        this.order.NewOrderItems[
                            index
                        ].order_review_items.length;
                    this.current_index = index;
                    this.isLoader = false;
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },
        onSelectRemainingItem(index) {
            this.isLoader = true;
            this.getSingleOrderReview(this.order.NewOrderItems[index])
                .then(() => {
                    this.version =
                        this.order.NewOrderItems[
                            index
                        ].order_review_items.length;
                    this.current_index = 0;
                    [
                        this.order.NewOrderItems[0],
                        this.order.NewOrderItems[index]
                    ] = [
                        this.order.NewOrderItems[index],
                        this.order.NewOrderItems[0]
                    ];
                    this.orderFunction();
                    this.isLoader = false;
                })
                .catch(() => {
                    this.isLoader = false;
                });
        },
        getSingleOrderReview(order_item) {
            let params = {
                unique_item_id: order_item.unique_item_id,
                order_id: this.$route.params.id,
                size_group_id: order_item.gender_size_id,
                color_id: order_item.color.id,
                product_id: order_item.id
            };
            return new Promise((resolve, reject) => {
                ApiService.post("/order-review", params)
                    .then(async ({ data }) => {
                        let order_review_items =
                            data.order_review_master.OrderReviewItems.filter(
                                (review_item) =>
                                    review_item.product_id == order_item.id &&
                                    review_item.color_id ==
                                        order_item.color.id &&
                                    review_item.size_group_id ==
                                        order_item.gender_size_id &&
                                    review_item.unique_item_id ==
                                        order_item.unique_item_id
                            );

                        if (
                            order_review_items[order_review_items.length - 1] &&
                            order_review_items[order_review_items.length - 1]
                                .modified_fees
                        ) {
                            this.modified_fees = JSON.parse(
                                order_review_items[
                                    order_review_items.length - 1
                                ].modified_fees
                            );
                        }

                        let comments = await this.getOrderReviewComments(
                            this.$route.params.id
                        );

                        order_review_items.forEach((review_item) => {
                            review_item.total_decoration_fee = 0;
                            review_item.OrderReviewFees.forEach(
                                (decoration) => {
                                    review_item.total_decoration_fee +=
                                        parseFloat(decoration.decoration_fee);
                                }
                            );

                            review_item.design_images =
                                review_item.design_images
                                    ? JSON.parse(review_item.design_images)
                                    : [];

                            if (review_item.design_images.length > 0) {
                                review_item.design_images[0].active_tab = true;
                            }

                            review_item.OrderReviewComments = comments.filter(
                                (comment) =>
                                    !comment.order_review_item_id ||
                                    comment.order_review_item_id ==
                                        review_item.id
                            );
                        });

                        order_item["order_review_items"] = order_review_items;
                        resolve(data);
                    })
                    .catch((response) => {
                        console.log(response);
                        reject(response);
                    });
            });
        },
        getOrderReviewComments(order_id) {
            return new Promise((resolve, reject) => {
                ApiService.query("/order-review-comments", {
                    params: { order_id }
                })
                    .then(({ data }) => {
                        resolve(data.comments);
                    })
                    .catch((err) => {
                        reject(err);
                    });
            });
        },
        async postReviewComment() {
            this.comment = this.comment.trim();
            if (!this.comment && !this.attachment) {
                return;
            }
            let params = {
                order_id: this.order.id,
                order_review_item_id:
                    this.order.NewOrderItems[this.current_index]
                        .order_review_items[this.version - 1].id,
                comment: this.comment,
                attachment: this.attachment,
                user_id: this.order.user_id
            };
            this.isLoader = true;
            ApiService.post("/order-review-comment", params)
                .then(async () => {
                    await this.getSingleOrderReview(
                        this.order.NewOrderItems[this.current_index]
                    );
                    this.isLoader = false;
                    this.comment = "";
                    this.attachment = "";
                })
                .catch((response) => {
                    this.isLoader = false;
                    console.log(response);
                });
        },
        sendMail() {
            this.$validator.validateAll("reviewmailform").then((isValid) => {
                if (!isValid) {
                    return;
                }
                this.isLoader = true;
                this.mail.unique_order_id = this.order.unique_order_id;
                ApiService.post("/order-review-mail", this.mail)
                    .then(() => {
                        this.isLoader = false;
                        this.mail = {
                            email: "",
                            message: "",
                            unique_order_id: this.order.unique_order_id,
                            current_link:
                                window.location.origin +
                                "/orderproofreview/" +
                                this.$route.params.id
                        };
                        /* eslint-disable */
                        $("#opr_share_popup").modal("hide");
                        /* eslint-enable */
                    })
                    .catch((response) => {
                        this.isLoader = false;
                        console.log(response);
                    });
            });
        },
        showGrandTotalPrice(item) {
            let item_total_price = parseFloat(item.total_price);
            let item_decoration_fee = parseFloat(
                item.order_review_items[0].total_decoration_fee
            );
            let order_decoration_fee = this.order.total_order_fee
                ? parseFloat(this.order.total_order_fee)
                : 0;
            let total_design_fee =
                parseInt(item.total_quantity) *
                (item_decoration_fee + order_decoration_fee);
            item_total_price = item_total_price + total_design_fee;
            return parseFloat(item_total_price).toFixed(2);
        },
        approveArtwork() {
            let params = {
                order_review_item_id:
                    this.order.NewOrderItems[this.current_index]
                        .order_review_items[this.version - 1].id,
                order_id: this.order.id,
                all_items_approved: false
            };
            let approved_items = 1;
            this.order.NewOrderItems.forEach((order_item, index) => {
                if (this.current_index != index) {
                    let approved = order_item.order_review_items.find(
                        (review_item) => review_item.status == "APPROVED"
                    );
                    if (approved) {
                        approved_items++;
                    }
                }
            });
            if (approved_items == this.order.NewOrderItems.length) {
                params["all_items_approved"] = true;
            }
            return new Promise((resolve, reject) => {
                this.isLoader = true;
                ApiService.post("/approve-artwork", params)
                    .then(({ data }) => {
                        this.isLoader = false;
                        this.approved = true;
                        this.order.NewOrderItems[
                            this.current_index
                        ].order_review_items[this.version - 1].status =
                            "APPROVED";
                        resolve(data);
                    })
                    .catch(({ response }) => {
                        this.isLoader = false;
                        reject(response);
                    });
            });
        },
        /* eslint-disable */
        async approveWithModification() {
            if (!this.comment) {
                return;
            }
            await this.postReviewComment();

            $("#approved_with_modification").toggleClass("d-none");
            $("#approved_with_modification_msg").toggleClass("d-none");

            this.approveArtwork();
        },
        async resendProofWithUpdates() {
            if (!this.comment) {
                return;
            }
            await this.postReviewComment();

            $("#resend_with_proof_updates").toggleClass("d-none");
            $("#resend_with_proof_updates_msg").toggleClass("d-none");
        },
        /* eslint-enable */
        attachImage(event) {
            let reader = new FileReader();
            reader.onload = (e) => {
                let img = new Image();
                img.onload = () => {
                    let image_width = img.width;
                    let image_height = img.height;
                    let image_size = event.target.files[0].size / (1024 * 1024);
                    let image_uploaded = {
                        image: e.target.result,
                        size: image_size.toFixed(2) + "MB",
                        dimension: image_width + "x" + image_height
                    };
                    this.isLoader = true;
                    ApiService.post("/image_upload_to_s3", image_uploaded)
                        .then(async ({ data }) => {
                            this.attachment = data.image_file_path;
                            await this.postReviewComment();
                            event.target.value = null;
                            this.isLoader = false;
                        })
                        .catch(() => {
                            this.isLoader = false;
                        });
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(event.target.files[0]);
        },
        onChangeVersionApproval(version_id) {
            if (version_id) {
                this.version = version_id;
            }
        },
        activeDesignImageTab(designImage) {
            this.order.NewOrderItems[this.current_index].order_review_items[
                this.version - 1
            ].design_images.forEach((image) => {
                if (designImage.label == image.label) {
                    image.active_tab = true;
                } else {
                    image.active_tab = false;
                }
            });
            this.$forceUpdate();
        },
        onTypeComment(event) {
            if (event.key == "Enter") {
                this.postReviewComment();
            }
        },
        async refreshComments() {
            this.isLoader = true;
            let comments = await this.getOrderReviewComments(
                this.$route.params.id
            );
            let order_review_item_id =
                this.order.NewOrderItems[this.current_index].order_review_items[
                    this.version - 1
                ].id;
            this.order.NewOrderItems[this.current_index].order_review_items[
                this.version - 1
            ].OrderReviewComments = comments.filter(
                (comment) =>
                    !comment.order_review_item_id ||
                    comment.order_review_item_id == order_review_item_id
            );
            this.isLoader = false;
        }
    }
};
</script>
<style>
.proof_review_main .section_to_print {
    display: none;
}

@media print {
    .proof_review_main .no-print,
    .no-print * {
        display: none !important;
    }

    .proof_review_main .section_to_print {
        display: block !important;
    }

    * {
        size: A4;
        -webkit-print-color-adjust: exact !important;
        /* Chrome, Safari 6 – 15.3, Edge */
        color-adjust: exact !important;
        /* Firefox 48 – 96 */
    }
}
.proof_review_main .opr_chat_popup_box .modal-dialog-scrollable .modal-header {
    padding: 20px 56px;
}
.proof_review_main .opr_chat_popup_box .modal-dialog-scrollable .modal-content {
    padding-bottom: 15px;
}
.proof_review_main .opr_version_image_sec .opr_version_img img {
    max-height: 350px;
    padding: 10px 0px;
    width: 100%;
    /* max-width: 100% !important; */
    object-fit: cover;
}
.proof_review_main .opr_proof_carefilly {
    margin: 30px 0px 60px !important;
}
</style>
